export const SWEDEN_LAT_LNG = {
  lat: 60.1282,
  lng: 18.6435
};

export const DENMARK_LAT_LNG = {
  lat: 55.455543,
  lng: 11.790273
};
